// extracted by mini-css-extract-plugin
module.exports = {"links":"ArtistDetailsLinks-links-1HGFh","link":"ArtistDetailsLinks-link-FonOG","linkLabel":"ArtistDetailsLinks-linkLabel-1wi-2 Label-label-30Bqv"};